export const QUERY__TRANSACTION_HISTORY = 'transaction-history';
export const QUERY__USER_TRANSACTIONS = 'user-transactions';
export const QUERY__USER_POOL_TRANSACTIONS = 'user-pool-transactions';
export const QUERY__ALL_POOL_TRANSACTIONS = 'all-pool-transactions';
export const QUERY__USER_DEPOSITS = 'user-deposits';
export const QUERY__USER_PAYOUTS = 'user-payouts';
export const QUERY__DEPOSIT_DETAILS = 'deposit-details';
export const QUERY__DEPOSIT_LOGS = 'deposit-logs';
export const QUERY__PAYOUT_DETAILS = 'payout-details';
export const QUERY__PAYOUT_LOGS = 'payout-logs';
export const QUERY__ALL_TRANSACTIONS = 'all-transactions';
export const QUERY__ALL_DEPOSITS = 'all-deposits';
export const QUERY__ALL_PAYOUTS = 'all-payouts';
